import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import { multiply } from "lodash";

class ScroollTableKoga3arz extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const { HK_all3arzKala, HK_code, HK_name, HK_draw } = value;
            let arr = [];
            for (let i = HK_all3arzKala.length; i > 0; i--) {
              const el = HK_all3arzKala[i - 1];
              if (el) {
                arr = [...arr, el];
              }
            }
            const wakelRaport = arr
              .filter((data) => {
                if (HK_name != "") {
                  return data.nameofproduct
                    .toLowerCase()
                    .startsWith(HK_name.toLowerCase());
                } else if (HK_code != "") {
                  return data.code.toString().startsWith(HK_code);
                } else {
                  return data;
                }
              })
              .map((user, i) => {
                return (
                  <>
                    {HK_draw == "دۆلار" || HK_draw == "دینار" ? (
                      <tr key={i} className="f4">
                        <td
                          className="fk"
                          style={{ border: "2px solid #f0ad4e" }}
                        >
                          {HK_draw == "دۆلار" ? (
                            Number(
                              multiply(
                                Number(user.numberOfDarzan),
                                Number(user.saleDolar)
                              )
                            ).toFixed(2)
                          ) : HK_draw == "دینار" ? (
                            <NumberFormat
                              value={multiply(
                                Number(user.numberOfDarzan).toFixed(2),
                                Number(user.saleDinar).toFixed(2)
                              )}
                              thousandSeparator={true}
                              displayType="text"
                            />
                          ) : null}
                        </td>

                        {HK_draw == "دۆلار" ? (
                          <>
                            {" "}
                            <td
                              className="fk"
                              style={{ border: "2px solid #f0ad4e" }}
                            >
                              {Number(user.saleDolar).toFixed(2)}
                            </td>
                          </>
                        ) : HK_draw == "دینار" ? (
                          <>
                            {" "}
                            <td
                              className="fk"
                              style={{ border: "2px solid #f0ad4e" }}
                            >
                              <NumberFormat
                                value={Number(user.saleOfLessTenDarzan)}
                                thousandSeparator={true}
                                displayType="text"
                              />
                            </td>
                            <td
                              className="fk"
                              style={{ border: "2px solid #f0ad4e" }}
                            >
                              <NumberFormat
                                value={Number(user.saleOfLessHalfCarton)}
                                thousandSeparator={true}
                                displayType="text"
                              />
                            </td>
                            <td
                              className="fk"
                              style={{ border: "2px solid #f0ad4e" }}
                            >
                              <NumberFormat
                                value={Number(user.saleDinar)}
                                thousandSeparator={true}
                                displayType="text"
                              />
                            </td>
                          </>
                        ) : null}
                        <td
                          className="fk"
                          style={{ border: "2px solid #f0ad4e" }}
                        >
                          {Number(multiply(user.numberOfDarzan, 12)).toFixed(2)}
                        </td>
                        <td
                          className="fk"
                          style={{ border: "2px solid #f0ad4e" }}
                        >
                          {user.numberOfDarzan}
                        </td>
                        <td
                          className="fk"
                          style={{ border: "2px solid #f0ad4e" }}
                        >
                          1
                        </td>
                        <td
                          className="fk"
                          style={{ border: "2px solid #f0ad4e" }}
                        >
                          {user.nameofproduct}
                        </td>
                        <td
                          className="fk"
                          style={{ border: "2px solid #f0ad4e" }}
                        >
                          {user.code}
                        </td>
                      </tr>
                    ) : null}
                  </>
                );
              });

            return (
              <div className="JM">
                <table
                  id="example"
                  className="table table-hover table-bordered text-right "
                >
                  <thead>
                    <tr
                      className="text-warning f4"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        نرخ کارتۆن
                      </th>
                      {HK_draw == "دۆلار" ? (
                        <>
                          <th style={{ border: "2px solid #f0ad4e" }}>
                            نرخ دەرزەن
                          </th>
                        </>
                      ) : HK_draw == "دینار" ? (
                        <>
                          <th style={{ border: "2px solid #f0ad4e" }}>
                            کەمتر لە 10
                          </th>
                          <th style={{ border: "2px solid #f0ad4e" }}>
                            کەمتر لە نیو
                          </th>
                          <th style={{ border: "2px solid #f0ad4e" }}>
                            نرخ دەرزەن
                          </th>
                        </>
                      ) : null}
                      <th style={{ border: "2px solid #f0ad4e" }}>عدد</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>دەرزەن</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>کارتۆن</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        ناوەی کاڵا
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>کۆد</th>
                    </tr>
                  </thead>
                  <tbody>{wakelRaport}</tbody>
                </table>
              </div>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default ScroollTableKoga3arz;
